import { ToastService } from './../../../../widgets/entry-components/toast/services/toast.service';
import { ChBaseComponent } from './../ch-base/ch-base.component';
import { PrevRouteService } from './../../../../routing/services/prev-route.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { FormGroup, FormControl } from '@angular/forms';

const PW = { type: 'password', icon: 'eye' };
const TEXT = { type: 'text', icon: 'eye-off' };

@Component({
  selector: 'inc-ch-password',
  templateUrl: './ch-password.component.html',
  styleUrls: ['./ch-password.component.scss'],
})
export class ChPasswordComponent extends ChBaseComponent implements OnInit {
  inputs = [PW, PW, PW];
  @Output() callSave = new EventEmitter<string>();

  constructor(
    prevRouteService: PrevRouteService, router: Router,
    storage: Storage,
    private toastService: ToastService
  ) {
    super(prevRouteService, router, storage);
  }

  ngOnInit() {
    this.reset();
  }

  reset(): void {
    this.inputs = [PW, PW, PW];
    this.form = this.resetForm();
  }

  resetForm(): FormGroup {
    return new FormGroup({
      newPassword: new FormControl(''),
      reNewPassword: new FormControl('')
    });
  }

  reAuthenticate() {
    this.setMustRelogin();
    if (this.form.value.newPassword === this.form.value.reNewPassword) {
      this.callSave.emit(this.form.value.reNewPassword);
    } else {
      this.toastService.presentToast('PASSWORD_MISSMATCH');
    }
  }

  togglePwVisibility(index: number) {
    this.inputs[index] = (this.inputs[index] === PW) ? TEXT : PW;
  }

}
